import React from 'react';
import { verifyRouter } from '../common/verify-router';
import { DefaultParamProvider } from '../common/default-param-provider';
import { ScopeUpdater } from './scope-updater';
import { scopeFormatter } from './scope-formatter';
import { IHistory, ILocation } from '../types';

type DefaultParamProviderProps = React.ComponentProps<typeof DefaultParamProvider>;

export interface IScopeProviderProps {
  location?: ILocation;
  history?: IHistory;
  scope?: DefaultParamProviderProps['defaults'];
  allowedKeys?: DefaultParamProviderProps['allowedKeys'];
  updateQuery?: boolean;
  paramFormatter?: DefaultParamProviderProps['paramFormatter'];
  updateOnPathChange?: DefaultParamProviderProps['updateOnPathChange'];
  children: React.ReactNode;
}

export function ScopeProvider({
  location,
  history,
  scope,
  allowedKeys,
  updateQuery,
  paramFormatter,
  children,
  updateOnPathChange,
}: IScopeProviderProps) {
  return (
    <DefaultParamProvider

      defaults={updateQuery ? null : scope}
      allowedKeys={allowedKeys}
      paramFormatter={paramFormatter}
      location={location}
      history={history}
      updateOnPathChange={updateOnPathChange}
    >
      {updateQuery ? (<ScopeUpdater defaults={scope} />) : null}
      {children}
    </DefaultParamProvider>
  );
}

ScopeProvider.defaultProps = {
  location: undefined,
  history: undefined,
  scope: DefaultParamProvider.defaultProps.defaults,
  allowedKeys: DefaultParamProvider.defaultProps.allowedKeys,
  updateQuery: true,
  updateOnPathChange: true,
  paramFormatter: scopeFormatter,
};

export const DefaultScopeProvider: React.FC<IScopeProviderProps> = verifyRouter(ScopeProvider);
